import { readUserLocationCookie } from "./cookie";

const getPostCode = () => {
  const userLocation = readUserLocationCookie();
  return userLocation ? userLocation.postCode : null;
};

export default getPostCode;